import { Container, Flex, Box } from 'theme-ui';
import SaveZipCodes from '../components/SaveZipCodes';
import { headerWrapper, MenuButtonContainer } from './Navbar.styled';
import BulkAdd from './BulkAdd';
import BulkDeliveryRules from './BulkDeliveryRules';
import Breadcrumbs from './Breadcrumbs';
import SelectionTools from './SelectionTools';
export default function Navbar() {
  return (
    <header
      sx={{
        width: '100%',
        flex: 'inherit',
        variant: 'layout.header',
      }}
    >
      <Container paddingX={[4, 4, 11]} sx={headerWrapper}>
        <Flex sx={{ width: '100%' }}>
          <Breadcrumbs />
          <Box sx={MenuButtonContainer} style={{ textAlign: 'right' }}>
            <SelectionTools />
            <BulkAdd />
            <BulkDeliveryRules />
            <SaveZipCodes />
          </Box>
        </Flex>
      </Container>
    </header>
  );
}
